'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { isSubscriber } from '@alltrails/context/utils/isSubscriber';
import { getItem } from '@alltrails/local-storage/utils';

const GenericPostAuthUpsellModal = dynamic(() => import('../GenericPostAuthUpsell/PostAuthUpsellModal'), {
  ssr: false
});

const snoozeDurationDays = 14 * 1000 * 60 * 60 * 24; // 14 days

export default function ReturningUserUpsell() {
  const user = useUser();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Prevent showing this upsell with apple redirect upsell
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('apple_oauth')) {
      return;
    }

    const lastDisplayTime = getItem<number>('post-auth-upsell');

    if (user && !isSubscriber(user) && ((lastDisplayTime && new Date().getTime() - lastDisplayTime >= snoozeDurationDays) || !lastDisplayTime)) {
      setIsOpen(true);
    }
    // we don't want to run this after sign up modal or google one tap updates the user which would show two upsells
  }, []);

  if (isOpen) {
    return (
      <GenericPostAuthUpsellModal
        isOpen={isOpen}
        onCloseRequest={() => {
          setIsOpen(false);
        }}
        upsellTrigger="Returning user page view"
      />
    );
  }

  return null;
}
